"use client";
import config from "@/config";
import { Pricelist } from "@/lib/centra/formatters";
import usePriceList from "@/lib/centra/usePriceList";
import clsx from "clsx";
import styles from "./product-tag.module.css";

type Props = {
  prices: Pricelist;
};

/**
 * Client-side component that displays a sale tag when a product is on sale,
 * or a free tag when a product is free.
 * Uses the selection price list to determine sale/free status.
 * @param prices
 * @returns Sale/Free tag element if applicable, null otherwise
 */
export function ClientSaleTag({ prices }: Props) {
  const price = usePriceList(prices);

  // Check if product is free (price is 0)
  if (price.priceAsNumber === 0) {
    return (
      <span className={clsx(styles.tag, styles.free)}>{config.tags.free}</span>
    );
  }

  // Check if product is on sale
  if (price.showAsOnSale) {
    return (
      <span className={clsx(styles.tag, styles.sale)}>{config.tags.sale}</span>
    );
  }

  return null;
}
